<template>
  <div class="changed-box-container">
    <div class="changed-box-container__prepend">
      <ChangedBox :active="active" />
    </div>
    <slot name="middle" />
    <slot />
  </div>
</template>

<script>
import ChangedBox from '@/components/parts/ChangedBox.vue'
export default {
  components: {
    ChangedBox
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="scss" scoped>
.changed-box-container {
  position: relative;
  padding-left: 16px;

  &__prepend {
    position: absolute;
    left: 0;
    z-index: 1;
  }
}
</style>